// extracted by mini-css-extract-plugin
module.exports = {"content":"eA","container":"eB","title":"eC","text":"eD","textForm":"eE","submitButton":"eF"};